import type { OnboardingSurveyId } from "@mirage/service-onboarding-surveys/service";
import { useMemo } from "react";

export const useSelfServeProfilingSurveyName = (
  isAdmin: boolean,
  canProvisionDashFreemiumTeam: boolean = false,
) => {
  const surveyName = useMemo(
    () =>
      isAdmin || canProvisionDashFreemiumTeam
        ? "ADMIN_PROFILING_V1"
        : "TEAM_MEMBER_PROFILING_V1",
    [canProvisionDashFreemiumTeam, isAdmin],
  ) as OnboardingSurveyId;

  return { surveyName };
};
